import { createYmaps } from 'vue-yandex-maps';

import type { CustomElementOptions } from 'vue';
import type { Router, RouterMatcher } from 'vue-router';

type App = Parameters<NonNullable<CustomElementOptions['configureApp']>>[0];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const initPlugins = (app: App, router: Router, matcher: RouterMatcher) => {
  app.config.compilerOptions.isCustomElement = (tag) => tag.startsWith('partner-widget');

  app.use(
    createYmaps({
      apikey: import.meta.env.VITE_YANDEX_MAP_KEY,
    }),
  );
};
